<!-- ═══ REVIEW USER CONSOLE ═══ -->
<div class="ru-console">
  <ngx-loading [show]="isLoading"></ngx-loading>

  <!-- ── Top Bar ── -->
  <div class="ru-console__topbar d-flex align-items-center gap-2">
    <span class="ru-console__led ru-console__led--green"></span>
    <span class="ru-console__led ru-console__led--amber"></span>
    <span class="ru-console__led ru-console__led--red"></span>
    <span class="ru-console__topbar-title ms-2">PLAYER·REVIEW</span>
  </div>

  <!-- ── Divider ── -->
  <div class="ru-console__divider d-flex align-items-center gap-2 my-2">
    <span class="ru-console__divider-line flex-grow-1"></span>
    <span class="ru-console__divider-label">SELECT·AGENT</span>
    <span class="ru-console__divider-line flex-grow-1"></span>
  </div>

  <!-- ── Search Bezel ── -->
  <div class="ru-console__bezel mb-3">
    <span class="ru-console__screw ru-console__screw--tl"></span>
    <span class="ru-console__screw ru-console__screw--tr"></span>
    <span class="ru-console__screw ru-console__screw--bl"></span>
    <span class="ru-console__screw ru-console__screw--br"></span>

    <div class="ru-console__screen p-2">
      <div class="ru-console__scanlines" aria-hidden="true"></div>
      <div class="row align-items-center g-2" style="position: relative; z-index: 2">
        <div class="col-auto" *ngIf="user?.userData?.avatarUrl || user?.avatarUrl">
          <div class="ru-avatar">
            <app-user-template [user]="user" [displayUserName]="false" tooltipField="userData.status">
            </app-user-template>
          </div>
        </div>
        <div class="col">
          <app-agent-input-autocomplete
            (selectionChange)="onSelectUser($event)"
            (agentsLoad)="isLoading = false"
            [withTeam]="true"
            [placeholder]="'ADMIN_REVIEW_USER.SELECT_USER_PLACEHOLDER' | translate"
            [placeholderLabel]="'ADMIN_REVIEW_FEEDBACK.SELECT_USER.INPUT_PLACEHOLDER' | translate"
          ></app-agent-input-autocomplete>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Details View ── -->
  <app-review-user-details-view [user]="user"></app-review-user-details-view>
</div>
